(function() {
    /*
     * custom provider for language support by user browser settings
     * and cookies
     *
     * injected in configuration and ajs controllers
     */

    'use strict';

    angular.module('app').provider('csLanguage', csLanguageProvider);

    function csLanguageProvider() {
        this.$get = [
            '$cookies',
            '$window',
            function($cookies, $window) {
                return {
                    language: 'en',
                    available: ['pl', 'en', 'de'],
                    getAvailable: function() {
                        return this.available;
                    },
                    browser: function() {
                        var lg = this.language;
                        var browser = $window.navigator.language || $window.navigator.userLanguage;

                        if (browser) {
                            browser = browser.slice(0, 2);
                            if (this.available.indexOf(browser) >= 0) {
                                lg = browser;
                            }
                        }
                        return lg;
                    },
                    cookie: function(name) {
                        var lg = false;
                        var cookie = $cookies.get(name);

                        if (cookie && this.available.indexOf(cookie) >= 0) {
                            lg = cookie;
                        }
                        return lg;
                    },
                    get: function(cookie) {
                        var lg = this.cookie(cookie);
                        return lg ? lg : this.browser();
                    },
                    settle: function(cookie, value) {
                        if (this.available.indexOf(value) >= 0) {
                            $cookies.put(cookie, value);
                        }
                    },
                };
            },
        ];
        this.getInitial = function(cookie) {
            var $cookies;
            angular.injector(['ngCookies']).invoke([
                '$cookies',
                function(_$cookies_) {
                    $cookies = _$cookies_;
                },
            ]);

            return $cookies.get(cookie) || 'en';
        };
    }
})();

var app = angular
    .module('app')
    .config([
        '$controllerProvider',
        '$compileProvider',
        '$filterProvider',
        '$provide',
        function($controllerProvider, $compileProvider, $filterProvider, $provide) {
            app.controller = $controllerProvider.register;
            app.directive = $compileProvider.directive;
            app.filter = $filterProvider.register;
            app.factory = $provide.factory;
            app.service = $provide.service;
            app.constant = $provide.constant;
            app.value = $provide.value;
        },
    ])
    .config([
        '$translateProvider',
        'bundle',
        function($translateProvider, bundle) {
            // Register a loader for the static files
            // So, the module will search missing translation tables under   the specified urls.
            // Those urls are [prefix][langKey][suffix].

            $translateProvider
                .useStaticFilesLoader({
                    prefix: 'dist/' + bundle + '/l10n/',
                    suffix: '.json',
                })
                .preferredLanguage('pl')
                .useSanitizeValueStrategy('escape')
                .useLocalStorage();
        },
    ])
    .config([
        '$httpProvider',
        function($httpProvider) {
            $httpProvider.interceptors.push('HttpResponseHooks');
        },
    ])
    .config([
        'uiGmapGoogleMapApiProvider',
        'csLanguageProvider',
        function(uiGmapGoogleMapApiProvider, csLanguageProvider) {
            var lang = csLanguageProvider.getInitial('lang');
            if (lang !== 'en') {
                lang = lang + '_' + lang.toUpperCase();
            }
 
            uiGmapGoogleMapApiProvider.configure({
                v: "3.45",
                language: lang,
                key: 'AIzaSyCAaiobJCCl_XNuJDCcHHTUAdEALhGgGUk',
                libraries: 'places,drawing',
            });
        },
    ])
    .config([
        'momentPickerProvider',
        'csLanguageProvider',
        function(momentPickerProvider, csLanguageProvider) {
            var lang = csLanguageProvider.getInitial('lang');

            momentPickerProvider.options({
                locale: lang,
                format: 'YYYY-MM-DD HH:mm:ss',
                minView: 'month',
                maxView: 'hour',
                startView: 'month',
                autoclose: true,
                today: true,
                minutesStep: 1,
                setOnSelect: true,
                hoursFormat: 'HH:[00]',
                minutesFormat: 'HH:mm',
            });
        },
    ])
    .config([
        'tmhDynamicLocaleProvider',
        function(tmhDynamicLocaleProvider) {
            tmhDynamicLocaleProvider.localeLocationPattern('libs/external/angular-i18n/angular-locale_{{locale}}.js');
        },
    ]);
